import {HighlightService} from './highlight.service';

const some = require('lodash/some');

class PrmHighlight {
    private terms:string[];
    private text:string;
    private highlightRegexp: RegExp;
    private highlightedText: string;
    private displayMode:string;
    private isBidi:boolean;

    constructor(private $element: ng.IRootElementService, private $scope: angular.IScope, private highlightService: HighlightService) {

    }

    $onInit() {
        if(this.isNotEmptyTerms()) {
            this.highlightRegexp = this.highlightService.getTermRegexp(this.terms);
        }
        let res = this.highlightService.bidirectionalText(this.text);
        this.isBidi = res.isBidi;
        this.highlightedText = this.highlightService.getHighlightedText(res.fixedStr, this.highlightRegexp);
    }
    $onChanges(changesObj) {
        if('terms' in changesObj) {
            this.highlightRegexp = this.highlightService.getTermRegexp(this.terms);
            this.highlightedText = this.highlightService.getHighlightedText(this.text, this.highlightRegexp);

        }
        else if('text' in changesObj) {
            this.highlightedText = this.highlightService.getHighlightedText(this.text, this.highlightRegexp);
        }

    }

    private isNotEmptyTerms(){
        if(this.terms&&Array.isArray(this.terms)&&this.terms.filter(e => e.length > 0).length>0){
            return true;
        }else{
            //console.error('Invalid terms', this.terms);
            return false;
        }

    }

    public isEmailMode() {
        return this.displayMode === 'email';
    }
}

PrmHighlight.$inject = ['$element', '$scope', 'HighlightService'];

export default {
    name: 'prmHighlight',
    config: {
        bindings: {
            terms: '<',
            text: '<',
            displayMode: '<'
        },
        controller: PrmHighlight,
        templateUrl: 'components/infra/highlight.html'
    }
};




// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/highlight.directive.ts